import React from 'react';

export default () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="7" height="5" viewBox="0 0 7 5" fill="none">
    <path d="M3.73709 0.805807L6.22608 4.01618C6.37891 4.21331 6.23842 4.5 5.98899 4.5L1.01101 4.5C0.761582 4.5 0.621091 4.21331 0.773921 4.01618L3.26291 0.805807C3.38301 0.650894 3.61699 0.650894 3.73709 0.805807Z" fill="currentColor" />
  </svg>
);

